// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2BDZY","header":"PatientQuestionnaire_header__1D_gT","info":"PatientQuestionnaire_info__2r53w"};